export const warehouseStaffRoute = {
  base: '/warehouse-staff',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const warehouseStaffRouteVehicles = {
  vehicles: `${warehouseStaffRoute.base}${warehouseStaffRoute.vehicles}`,
};

export const warehouseStaffRouteTrucks = {
  trucks: `${warehouseStaffRoute.base}${warehouseStaffRoute.vehicles}${warehouseStaffRoute.trucks}`,
};

export const warehouseStaffRouteEquipments = {
  equipments: `${warehouseStaffRoute.base}${warehouseStaffRoute.vehicles}${warehouseStaffRoute.equipments}`,
};

export const warehouseStaffRouteTrailers = {
  trailers: `${warehouseStaffRoute.base}${warehouseStaffRoute.vehicles}${warehouseStaffRoute.trailers}`,
};

export const warehouseStaffRouteVendors = {
  vendors: `${warehouseStaffRoute.base}${warehouseStaffRoute.vendors}`,
  detailVendor: `${warehouseStaffRoute.base}${warehouseStaffRoute.vendors}${warehouseStaffRoute.commonDetail}`,
};

export const warehouseStaffRoutePurchaseOrder = {
  purchaseOrder: `${warehouseStaffRoute.base}${warehouseStaffRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const warehouseStaffRouteOrder = {
  order: `${warehouseStaffRoute.base}${warehouseStaffRoute.order}`,
  detailOrder: (orderId: string) => `${warehouseStaffRoute.base}${warehouseStaffRoute.order}/${orderId}`,
  updateOrder: (orderId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.order}/${orderId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRouteCrm = {
  crm: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}`,
  leads: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.leads}`,
  createLead: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.leads}${warehouseStaffRoute.commonCreate}`,
  detailLead: (leadId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.leads}/${leadId}${warehouseStaffRoute.commonEdit}`,
  clients: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.clients}`,
  createClient: `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.clients}${warehouseStaffRoute.commonCreate}`,
  detailClient: (clientId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.crm}${warehouseStaffRoute.clients}/${clientId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRouteQuote = {
  quotes: `${warehouseStaffRoute.base}${warehouseStaffRoute.quotes}`,
  createQuotes: `${warehouseStaffRoute.base}${warehouseStaffRoute.quotes}${warehouseStaffRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${warehouseStaffRoute.base}${warehouseStaffRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.quotes}/${quoteId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRouteInventory = {
  inventories: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}`,
  inventory: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.product}`,
  createInventory: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.product}${warehouseStaffRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.product}/${inventoryId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRoutePackage = {
  package: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.package}`,
  createPackage: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.package}${warehouseStaffRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.package}/${packageId}${warehouseStaffRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.package}/${packageId}${warehouseStaffRoute.commonClone}`,
};

export const warehouseStaffRouteUser = {
  users: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.users}`,
  createUser: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.users}${warehouseStaffRoute.commonCreate}`,
  detailUser: (userId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.users}/${userId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRouteVenue = {
  venue: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.venue}`,
  createVenue: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.venue}${warehouseStaffRoute.commonCreate}`,
  detailVenue: (venueId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.venue}/${venueId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRouteInvoice = {
  invoices: `${warehouseStaffRoute.base}${warehouseStaffRoute.invoice}`,
  createInvoice: `${warehouseStaffRoute.base}${warehouseStaffRoute.invoice}${warehouseStaffRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.invoice}/${invoiceId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRouteRoleManagement = {
  roleManagement: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.roleManagement}`,
  createRole: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.roleManagement}${warehouseStaffRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.roleManagement}/${roleId}${warehouseStaffRoute.commonEdit}`,
};

export const warehouseStaffRouteRoleCoupon = {
  coupon: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.coupon}`,
};

export const warehouseStaffRouteRoleEventType = {
  eventType: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.eventType}`,
};

export const warehouseStaffRouteRoleCategory = {
  category: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.category}`,
};

export const warehouseStaffRouteRoleChecklist = {
  checklist: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}${warehouseStaffRoute.checklist}`,
};

export const warehouseStaffRouteJob = {
  jobs: `${warehouseStaffRoute.base}${warehouseStaffRoute.jobs}`,
  detailJob: (jobId: string) => `${warehouseStaffRoute.base}${warehouseStaffRoute.jobs}/${jobId}`,
};

export const warehouseStaffRouteQuarantine = {
  quarantine: `${warehouseStaffRoute.base}${warehouseStaffRoute.inventory}${warehouseStaffRoute.quarantines}`,
};

export const warehouseStaffRouteTask = {
  task: `${warehouseStaffRoute.base}${warehouseStaffRoute.task}`,
};

export const warehouseStaffRouteGlobal = {
  global: `${warehouseStaffRoute.base}${warehouseStaffRoute.global}`,
};

export const warehouseStaffRouteReport = {
  reports: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}`,
  overbookingItem: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.overbookingItem}`,
  subrentalsReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.subrentalsReport}`,
  clientIncomeReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.clientIncomeReport}`,
  revenueReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.revenueReport}`,
  geographicRevenueReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.quoteRevenueReport}`,
  orderRevenueReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.orderRevenueReport}`,
  cancellationReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.cancellationReport}`,
  deliveryReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.deliveryReport}`,
  taskCompletionReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.taskCompletionReport}`,
  discountUsageReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.discountUsageReport}`,
  featureUtilizationReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.featureUtilizationReport}`,
  jobCostingReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.jobCostingReport}`,
  inventoryUsageReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.inventoryUsageReport}`,
  quarantineReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.quarantineReport}`,
  foremanTaskReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.foremanTaskReport}`,
  marketingRevenueReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.marketingRevenueReport}`,
  financialOrderReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.financialOrderReport}`,
  transactionSummaryReport: `${warehouseStaffRoute.base}${warehouseStaffRoute.reports}${warehouseStaffRoute.transactionSummaryReport}`,
};

export const warehouseStaffRouteAbsolute = {
  // Dashboard
  dashboard: warehouseStaffRoute.base,

  // Communication
  communication: `${warehouseStaffRoute.base}${warehouseStaffRoute.communication}`,

  // Settings
  settings: `${warehouseStaffRoute.base}${warehouseStaffRoute.settings}`,

  // Schedule
  schedule: `${warehouseStaffRoute.base}${warehouseStaffRoute.schedule}`,

  ...warehouseStaffRouteVehicles,
  ...warehouseStaffRouteTrucks,
  ...warehouseStaffRouteEquipments,
  ...warehouseStaffRouteTrailers,
  ...warehouseStaffRouteVendors,
  ...warehouseStaffRoutePurchaseOrder,
  ...warehouseStaffRouteOrder,
  ...warehouseStaffRouteCrm,
  ...warehouseStaffRouteQuote,
  ...warehouseStaffRouteInventory,
  ...warehouseStaffRoutePackage,
  ...warehouseStaffRouteUser,
  ...warehouseStaffRouteVenue,
  ...warehouseStaffRouteRoleManagement,
  ...warehouseStaffRouteRoleCoupon,
  ...warehouseStaffRouteRoleEventType,
  ...warehouseStaffRouteRoleCategory,
  ...warehouseStaffRouteRoleChecklist,
  ...warehouseStaffRouteJob,
  ...warehouseStaffRouteQuarantine,
  ...warehouseStaffRouteInvoice,
  ...warehouseStaffRouteReport,
  ...warehouseStaffRouteTask,
  ...warehouseStaffRouteGlobal,
};
